import React, { Component, useRef, useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

import NavMenu from './NavMenu';
import * as utils from './Utils.js'

import chandler from '../assets/faces/chandler.png';
import will from '../assets/faces/will.png';
import matt_c from '../assets/faces/matt_c.png';
import benji from '../assets/faces/benji.png';
import mike from '../assets/faces/mike.png';
import alan from '../assets/faces/alan.png';
import mark from '../assets/faces/mark.png';
import matt_m from '../assets/faces/matt_m.png';
import nick from '../assets/faces/nick.png';

import anna from '../assets/faces/anna.png';
import claire from '../assets/faces/claire.png';
import sam from '../assets/faces/sam.png';
import haley from '../assets/faces/haley.png';
import val from '../assets/faces/val.png';
import olivia from '../assets/faces/olivia.png';
import jessi from '../assets/faces/jessi.png';
import georgia from '../assets/faces/georgia.png';
import adriana from '../assets/faces/adriana.png';

const WeddingParty = () => {
  const { weddingPartyID } = useParams();

  useEffect(() => {
  }, [])

  const weddingPartyGroup = [
    {
      man: { firstName: 'Chandler', lastName: 'Crane', title: 'Groom', image: chandler },
      woman: { firstName: 'Anna', lastName: 'Lowney', title: 'Bride', image: anna }
    }
    ,
    {
      man: { firstName: 'Will', lastName: 'Cunningham', title: 'Best Man', image: will },
      woman: { firstName: 'Claire', lastName: 'Lowney', title: 'Maid of Honor', image: claire }
    },
    {
      man: { firstName: 'Matthew', lastName: 'Chignoli', title: 'Groomsman', image: matt_c },
      woman: { firstName: 'Haley', lastName: 'Holden', title: 'Bridesmaid', image: haley }
    },
    {
      man: { firstName: 'Benji', lastName: 'Backer', title: 'Groomsman', image: benji },
      woman: { firstName: 'Valentina', lastName: 'Trombetta', title: 'Bridesmaid', image: val }
    },
    {
      man: { firstName: 'Michael', lastName: 'Bianco', title: 'Groomsman', image: mike },
      woman: { firstName: 'Samantha', lastName: 'Monahan', title: 'Bridesmaid', image: sam }
    },
    {
      man: { firstName: 'Alan', lastName: 'Janowiak', title: 'Groomsman', image: alan },
      woman: { firstName: 'Olivia', lastName: 'Janowiak', title: 'Bridesmaid', image: olivia }
    },
    {
      man: { firstName: 'Mark', lastName: 'Lowney', title: 'Groomsman', image: mark },
      woman: { firstName: 'Jessi', lastName: 'Dirksen', title: 'Bridesmaid', image: jessi }
    },
    {
      man: { firstName: 'Matthew', lastName: 'Magiera', title: 'Groomsman', image: matt_m },
      woman: { firstName: 'Georgia', lastName: 'Crane', title: 'Bridesmaid', image: georgia }
    },
    {
      man: { firstName: 'Nicholas', lastName: 'Schleith', title: 'Groomsman', image: nick },
      woman: { firstName: 'Adriana', lastName: 'Alvez', title: 'Bridesmaid', image: adriana }
    }
  ]

  function displayWeddingPartyGroup (group) {
    return (
      <>
        <div className='wedding-party-column'>
          <div className='wedding-party-row'>
            <div className='wedding-groomsmen'>
              <div className='wedding-party-person'>
                <div className='wedding-party-person-name-group'>
                  <p className='wedding-party-person-name'>{ group.man.firstName }<span className='break-on-mobile'> </span>{ group.man.lastName }</p>
                  <p className='wedding-party-person-title'>{ group.man.title }</p>
                </div>
                <div className='wedding-party-person-face'>
                  <img src={ group.man.image }/>
                </div>
              </div>
            </div>

            <div className='wedding-party-divider'></div>

            <div className='wedding-bridesmaids'>
              <div className='wedding-party-person'>
                <div className='wedding-party-person-face'>
                  <img src={ group.woman.image }/>
                </div>
                <div className='wedding-party-person-name-group'>
                  <p className='wedding-party-person-name'>{ group.woman.firstName }<span className='break-on-mobile'> </span>{ group.woman.lastName }</p>
                  <p className='wedding-party-person-title'>{ group.woman.title }</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='centered-box'>
          { utils.displayCheckerboard(2, 42, ['multi', 'ivory']) }
        </div>
      </>
    )
  }

  if (weddingPartyID) {
    return (
      <div className="WeddingParty">
        <NavMenu page={'WeddingParty'}/>

        <div className='wedding-party-column'>
          <a href="/wedding-party">← Back to Wedding Party</a>

          { weddingPartyID }
        </div>
      </div>
    )
  } else {
    return (
      <div className="WeddingParty">
        <Helmet>
          <title>Wedding Party</title>
          <meta
            name="description"
            content="See the bridesmaids and groomsmen for Chandler & Anna's Wedding"
          />
  
          <meta property="og:title" content="Wedding Party | Chandler & Anna" />
          <meta
            property="og:description"
            content="See the bridesmaids and groomsmen for Chandler & Anna's Wedding"
          />
          <meta
            property="og:image"
            content="https://chandlerandanna.com/og/wedding_party.jpg"
          />
          <meta property="og:image:width" content="600" />
          <meta property="og:image:height" content="400" />
          <meta property="og:url" content="https://chandlerandanna.com/wedding-party" />
  
          <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
        <div className='wedding-centerpiece'>
          {
            weddingPartyGroup.map((group) => (
              displayWeddingPartyGroup(group)
            ))
          }
        </div>
      </div>
    );
  }
}

export default WeddingParty;
